/**
 * Tipo de artículo "bolsa". Es el único ítem de un remito que se enriquece con
 * la prescripción que produjo su lote (para una bolsa, `lot` ES su assercaId), y
 * el que va primero en el orden de impresión. Se exporta desde acá —junto al
 * comparador que lo usa— para que backend, reportes y frontend compartan la
 * misma constante en vez de repetir el literal.
 */
export const BAG_ARTICLE_TYPE = 'bag';

export interface RemitoItemOrderFields {
  articleType: string;
  itemCode: string;
  lot: string | null;
}

/**
 * Orden natural de negocio de los ítems de un remito: primero las bolsas
 * ordenadas por assercaId ascendente y después el resto de los artículos por
 * código ascendente.
 *
 * Para una bolsa el lote ES su assercaId (así lo graba el formulario y así lo
 * cruzan el reporte y el enriquecimiento de paciente/sector), por eso el orden
 * se deriva de campos ya persistidos y aplica también a remitos ya emitidos.
 */
export function compareRemitoItems(
  a: RemitoItemOrderFields,
  b: RemitoItemOrderFields
): number {
  const aIsBag = a.articleType === BAG_ARTICLE_TYPE;
  const bIsBag = b.articleType === BAG_ARTICLE_TYPE;
  if (aIsBag !== bIsBag) {
    return aIsBag ? -1 : 1;
  }

  const [left, right] = aIsBag
    ? [a.lot ?? '', b.lot ?? '']
    : [a.itemCode.trim(), b.itemCode.trim()];

  return left.localeCompare(right, undefined, { numeric: true });
}
